import { Component, OnInit } from '@angular/core';
import { RefundItemsComponent } from 'libs/shared/src/lib/component/refund/refund-items/refund-items.component';
import { LoaderStatus } from 'libs/core/src/lib/model/loading/loading-status.enum';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';

@Component({ standalone: false, selector: 'app-page-refund', templateUrl: './refund.component.html' })
export class CustomRefundItemsComponent extends RefundItemsComponent implements OnInit {
  override ngOnInit(): void {
    super.ngOnInit();
    this.onLoaderStateChange(LoaderStatus.stopped);
  }

  override changeLoaderState(state: LoaderStatus): void {
    super.changeLoaderState(state);
    this.onLoaderStateChange(state);
  }

  private onLoaderStateChange(state: LoaderStatus): void {
    if (state === LoaderStatus.pending) {
      this.loaderService.showLoader(LoaderEnum.MAIN);
      return;
    }

    this.loaderService.hideLoader(LoaderEnum.MAIN);
  }
}
